export const LineIcon = ({...props}) => {
    return (
        <>
            <svg width="1" height="42" viewBox="0 0 1 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="42" stroke="#D1D1D1"/>
            </svg>
        </>
    );
}
